import { Box, Typography } from '@mui/material';
import { kollectAITheme } from 'config/theme';
import { CiSearch } from 'react-icons/ci';

const SearchInput = ({
  filterKey,
  label,
  searchValue,
  placeholder,
  onSearch,
}: {
  filterKey: string;
  label: string;
  searchValue: string;
  placeholder: string;
  onSearch: (x: string, y: string) => void;
}) => {
  return (
    <Box>
      <Typography align='center'>{label}</Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25)',
          background: '#FFFFFF',
          borderRadius: '8px',
          padding: '0.4rem 0.5rem',
          gap: '0.5rem',
          height: '32px',

          '& svg': { marginTop: '2px' },
        }}
      >
        <CiSearch
          color={kollectAITheme.primaryColor}
          fontWeight={600}
          fontSize={20}
        />

        <input
          type='text'
          placeholder={placeholder}
          value={searchValue}
          onChange={(e) => {
            onSearch(filterKey, e.target.value);
          }}
          style={{
            background: 'transparent',
            border: 'transparent',
            outline: 'none',
            fontFamily: 'inherit',
            fontSize: '1rem',
            width: '150px',
          }}
        />
      </Box>
    </Box>
  );
};
export default SearchInput;
